

let texasPrecincts = ['0152', '0126', '0135' ]

// topCounties.sort(function(a, b){
//     if(a < b) { return -1; }
//     if(a > b) { return 1; }
//     return 0;
// })

// function alphabetize(arr) {
//   return arr.sort((a, b) => a.localeCompare(b))
// }


exports.texasPrecincts = texasPrecincts

    